import React from 'react';
import Contact from './contact';
import Parallax from './parallax';
const College = () => {
  return (
    <div className='flex flex-col justify-center text-center  w-full bg-light pt-[50px] px-5 py-4 md:px-[50px] md:py-[50px]'>
      <div className='bg-white rounded-[40px] p-4 md:p-0  md:py-[80px]'> 
        <div className='flex flex-col max-w-5xl m-auto gap-6'> 
      <div className=' heading-36 md:text-[56px]  font-bold text-center justify-center md:leading-snug w-full '>⁠Turn your College Event into the<span className='text-primary ml-5'>Talk of the Town!</span> 
      <div className=' text-14 md:text-18 justify-center text-center w-[80%] md:w-3/4  m-auto'> Imagine what you could do with the money saved on ticketing fees – better entertainment, cooler decorations, more refreshments! We help you maximize your event budget with our unbeatable commission.
      </div>

      </div>
      </div>
      <Parallax/>
      <Contact/>
        {/* Footer text
        <footer className="text-center text-gray-500 text-sm mt-10 py-5 px-2  ">
        TakeMyTickets © 2024. Made with love from India ❤️
      </footer> */}
      </div>
          
    </div>
  )
}

export default College